import React__default from 'react';
import '../../contexts/TranslationContext.js';
import '../../contexts/StoreContext.js';
import '../../core/enums/GameSpecificTypes.js';
import '../../core/enums/MaxPayoutDataTypes.js';
import '../../core/enums/Chat.js';
import '../../core/enums/GameModes.js';
import '../../core/enums/IconTypes.js';
import '../../core/enums/BetStatus.js';
import '../../core/enums/PopupTypes.js';
import '../../core/enums/ApiVersion.js';
import '../../core/enums/RoundStatus.js';
import '../../core/enums/FreeBetsStatus.js';
import '../../core/enums/SocketEvents.js';
import '../../core/enums/TranslationKeys.js';
import '../../core/enums/TimeoutMaxValue.js';
import '../../core/enums/ApiServiceTypes.js';
import '../../core/enums/EnvironmentTypes.js';
import '../../core/enums/DefaultQueryValues.js';
import '../../core/enums/FreeBetWinningType.js';
import '../../core/enums/DefaultQueryParams.js';
import '../../core/enums/BetHistoryFilterTypes.js';
import '../../core/enums/GameThemeTypes.js';
import '../../core/enums/RequestStatus.js';
import '../../core/enums/FetchDefaultPaths.js';
import '../../core/enums/ResponseCodes.js';
import '../../../loadingStore-2a98f12f.js';
import '../../core/store/chatStore.js';
import '../../core/store/wageringStore.js';
import '../../core/store/roundInfoStore.js';
import '../../core/store/userCountStore.js';
import '../../core/store/gameResultStore.js';
import '../../core/store/resultHashStore.js';
import '../../core/store/userWinBetsStore.js';
import '../../core/store/notificationStore.js';
import '../../core/store/selectedResultInfoStore.js';
import '../../core/services/liveConnection/types.js';
import 'axios';
import '../../core/services/sound/types.js';
import '../../core/services/sound/SoundService.js';
import '../../core/services/sound/defaultSounds.js';
import '../../core/services/api/types.js';
import '../../core/services/ApiServices.js';
import '../../../momentFormat-14fce7b4.js';
import '../../core/polyfill.js';
import 'react-router-dom';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver.js';
import '../../core/enums/additionalInputValueChangingButtons.js';
import '../../providers/storeProvider.js';
import '../underMaintenanceContainer/index.js';
import '../platformMessagesWrapper/index.js';
import '../../../index-57446b08.js';
import '../gameDrawingWrapper/index.js';
import '../../components/user-block/user-block-free-bet/index.js';
import '../../components/game-type-loading/index.js';
import '../../../tslib.es6-fe064bda.js';
import 'mobx';
import '@microsoft/signalr';
import '../../core/classes/httpResponse/index.js';
import '../../core/helpers/environmentBuilder.js';
import '../../core/enums/BogLineGameConfig.js';
import '../../core/helpers/parseQuery.js';
import '../../core/services/api/BaseApiService.js';
import '../../core/enums/StatisticsSortingTypes.js';
import '../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../table-line/t_types/enums/PopupTypes.js';
import '../../core/helpers/formatDate.js';
import '../../core/helpers/isMobile.js';
import '../../core/helpers/updateHalfBets.js';
import '../../core/enums/bogGameNames.js';
import 'howler';
import '../../../_commonjsHelpers-1a7a244d.js';
import 'mobx-react-lite';
import '../../../index-250ace75.js';
import '../../core/helpers/getAmountWithCurrency.js';
import '../../core/enums/Currencies.js';
import '../../hooks/useTranslation.js';
import '../../core/helpers/setTranslationValues.js';
import '../../../table-line/table-components/lobby/web/lobbyRoomWinner/index.js';
import '../../core/helpers/maskName.js';
import '../../core/helpers/exchangeAmountByRate.js';
import '../../core/helpers/getDataHelper.js';
import '../../core/helpers/rtlCheckerAndSetter.js';
import '../../hooks/useAssetsLoadedState.js';
import '../../hooks/useDisableFullScreenShortcuts.js';
import '../../../table-line/table-components/lobby/web/slider/index.js';
import '../../core/helpers/convertAmount.js';
import '../../components/free-bets/free-bet-info/index.js';
import '../../components/free-bets/free-bets-list/index.js';
import '../../hooks/useClickOutside.js';
import '../../../table-line/table-components/header/web/logoImg/index.js';
import '../../../table-line/table-components/notification/notification-type-component/index.js';
import '../../../table-line/table-components/notification/notification-wr/index.js';
import '../fullScreenWrapper/index.js';
import '../../hooks/useFullScreen.js';
import '../../../bog-line/components/snowFlakes/index.js';
import '../../../table-line/table-components/footer/web/footerUserInfoColumn/index.js';
import '../../../table-line/table-components/loading/index.js';
import '../../../table-line/table-components/lobbyLoadingInfoWr/index.js';
import '../../../table-line/table-components/setting/settingRowColumn/index.js';
import '../../../table-line/table-components/rightSide/rightSideIcon/index.js';
import '../../../table-line/table-components/rightSide/mobileNavigationRow/index.js';
import '../../../table-line/table-components/accordion/accordionItem.js';
import '../../../table-line/table-components/accordion/context.js';
import '../../core/helpers/cleanGameTypeIdFromQuery.js';
import '../../hooks/useLobbyStore.js';
import '../../hooks/useUserInfoStore.js';
import '../../../table-line/table-components/lobby/web/settingsButton/index.js';
import '../../../table-line/table-components/header/web/headerWr/index.js';
import '../../../table-line/table-components/header/web/headerColumn/index.js';
import '../../../table-line/table-components/header/web/fairnessButton/index.js';
import '../../../table-line/t_types/enums/GameControllerTypes.js';
import '../../../table-line/table-components/gameController/gameControllersWr/index.js';
import '../../../table-line/table-components/gameController/gameControllersHead/index.js';
import '../../../table-line/table-components/gameController/gameControllersContent/index.js';
import '../../core/enums/gameControllerTypes.js';
import '../../../table-line/table-components/gameController/gameControllersFooter/index.js';
import '../../hooks/useRoundInfoStore.js';
import '../../hooks/useUserCountStore.js';
import '../../hooks/useApplicationStore.js';
import '../../../table-line/table-components/grids/mobile/structureBottom/index.js';
import '../../../table-line/table-components/footer/mobile/footer-wr/index.js';
import '../../../table-line/table-components/footer/mobile/footer-column/index.js';
import '../../../table-line/table-components/footer/mobile/userBalanceAndTotalBet/index.js';
import '../../../table-line/table-components/footer/web/footerInfoSpan/index.js';
import '../../../table-line/table-components/footer/web/footerInfo/index.js';
import '../../core/helpers/getLocaleTime.js';
import '../../../table-line/table-components/footer/web/footerColumn/index.js';
import '../../../table-line/table-components/footer/web/footerUserInfo/index.js';
import '../../../table-line/table-components/footer/web/footerContainer/index.js';
import '../../../table-line/table-components/footer/web/userBalanceAndTotalBetAmount/index.js';
import '../../../table-line/table-components/footer/web/playForRealButtonHolder/index.js';
import '../../core/helpers/isIOS.js';
import '../../../table-line/table-components/setting/settingWr/index.js';
import '../../../table-line/table-components/setting/settingRow/index.js';
import '../../hooks/useOutsideClick.js';
import '../../../table-line/table-components/overlay/overlayLabel/index.js';
import '../../../table-line/table-components/overlay/overlayLabels/index.js';
import '../../../table-line/table-components/overlay/overlayListWr/index.js';
import '../../../table-line/table-components/overlay/overlayItem/index.js';
import '../../../table-line/table-components/overlay/overlayItemContent/index.js';
import '../../../table-line/table-components/overlay/overlayFooter/index.js';
import '../../../usePopupStore-5f91dee3.js';
import '../../../table-line/table-components/grids/mobile/structureTop/index.js';
import '../../../table-line/table-components/header/mobile/gameId/index.js';
import '../../../table-line/table-components/header/mobile/headerWr/index.js';
import '../../../table-line/table-components/header/mobile/headerLogo/index.js';
import '../../../table-line/table-components/header/mobile/headerColumn/index.js';
import '../../../table-line/table-components/header/mobile/fairnessButton/index.js';
import '../../../table-line/table-components/header/mobile/playForRealButtonHolder/index.js';
import '../../core/helpers/abbreviateNumber.js';
import '../../../table-line/table-components/header/mobile/minMaxBet/index.js';
import '../../../table-line/table-components/notification/connectionPopUp/index.js';
import '../../hooks/useSelectedResultInfoStore.js';
import '../../core/helpers/copyToClipboard.js';
import '../../hooks/useInfiniteScroll.js';
import '../../../table-line/table-components/accordion/accordion.js';
import '../../core/helpers/translateMonth.js';
import '../../../bog-line/components/grids/common/pop-up-wr-component/index.js';
import '../../../bog-line/components/list/list-item-with-image/index.js';
import '../../../bog-line/components/list/list/index.js';
import '../../../bog-line/components/list/list-header/index.js';
import '../../../bog-line/components/list/list-item-header/index.js';
import '../../../bog-line/components/list/list-body/index.js';
import '../../../bog-line/components/loading/component/index.js';
import '../../../bog-line/components/loading/logo/index.js';
import '../../../bog-line/components/loading/progress/index.js';
import '../../../bog-line/components/loading/provider/index.js';
import '../../../bog-line/components/loading/loader-content/index.js';
import 'react-dom';
import '../../../bog-line/components/popups/aboutHash.js';
import '../../hooks/useOpenBetHistory.js';
import '../../../bog-line/components/grids/common/column-body-inner/index.js';
import '../../../bog-line/components/grids/common/column-body-inner-bottom-wr/index.js';
import '../../../bog-line/components/grids/common/column-body-inner-top-wr/index.js';
import '../../../bog-line/components/tabs/tabs/index.js';
import '../../../bog-line/components/tabs/tab-item/index.js';
import '../../../bog-line/components/grids/common/column-header-block/index.js';
import '../../../bog-line/components/grids/common/column-header/index.js';
import '../../../bog-line/components/grids/common/column-header-block-inner/index.js';
import '../../../bog-line/components/icon-block/index.js';
import '../../../bog-line/components/chat/chatActions/index.js';
import '../horizontalScrollWrapper/index.js';
import '../../../bog-line/components/chat/chatLoader/index.js';
import '../../../bog-line/components/dots-loader/index.js';
import '../../../bog-line/components/list/list-header-filter/index.js';
import '../../../bog-line/components/list/list-item-header-filter/index.js';
import '../../../bog-line/components/grids/web/game/column/index.js';
import '../../../bog-line/components/grids/web/game/column-inner/index.js';
import '../../../bog-line/components/grids/web/game/column-middle-wr/index.js';
import '../../../bog-line/components/grids/web/game/column-header-wr/index.js';
import '../../../bog-line/components/user-block/user-info/index.js';
import '../../../bog-line/components/user-block/user-content/index.js';
import '../../../bog-line/components/play-for-real-button/index.js';
import '../../../bog-line/components/grids/web/game/column-body/index.js';
import '../../core/helpers/checkScrollToBottom.js';
import '../../core/enums/GameSceneCodes.js';
import '../../../bog-line/components/navigation/nav-item/index.js';
import '../../../bog-line/components/navigation/nav-row/index.js';
import '../../../bog-line/components/grids/mobile/game/main-cont/index.js';
import '../../../bog-line/components/grids/mobile/game/column/index.js';
import '../../../bog-line/components/notifications/connection-pop-up/index.js';
import '../../core/helpers/generateUId.js';
import '../../core/enums/BogLineGameConfigs.js';
import '../../core/helpers/gameDrawingSupportersFunctions.js';

var IntersectionObserverWrapper = function (_a) {
    var intersectionObserverSettings = _a.intersectionObserverSettings, elementRef = _a.elementRef, children = _a.children;
    var isVisible = useIntersectionObserver(elementRef, intersectionObserverSettings);
    return (isVisible === null || isVisible === void 0 ? void 0 : isVisible.isIntersecting) ? React__default.createElement(React__default.Fragment, null, children) : null;
};

export { IntersectionObserverWrapper };
